import type {FocusedMetaTags} from "./index.js";
import {submitMerge} from "@otto-ec/tracking-bct";
import {appType} from "../global/appInfo.js";

const META_TAG = {
    topBarVisibility: "apps-focused-layout-top-bar-visibility",
    bottomBarVisibility: "apps-focused-layout-bottom-bar-visibility",
    title: "apps-focused-layout-title",
} as const;

if (typeof window !== "undefined") {
    window.addEventListener("load", extractFocusedMetaTags);
    window.addEventListener("popstate", extractFocusedMetaTags);
}

/**
 *
 */
export function extractFocusedMetaTags(): void {
    if (!appType()) return;

    const readMeta = (name: string) =>
        document.head.querySelector(`meta[name=${name}]`)?.getAttribute("content");

    const topBar = readMeta(META_TAG.topBarVisibility);
    const bottomBar = readMeta(META_TAG.bottomBarVisibility);
    const title = readMeta(META_TAG.title);

    const metaJson: FocusedMetaTags = {};
    if (topBar === "hidden") metaJson.topBarVisibility = topBar;
    if (bottomBar === "hidden") metaJson.bottomBarVisibility = bottomBar;
    if (title) metaJson.title = title;

    const usedTags: string[] = [];
    if (metaJson.topBarVisibility != null) usedTags.push(META_TAG.topBarVisibility);
    if (metaJson.bottomBarVisibility != null) usedTags.push(META_TAG.bottomBarVisibility);
    if (usedTags.length > 0) {
        void submitMerge({app_MetaTagUsed: usedTags});
    }

    sendFocusedMetaJson(metaJson);
}

/**
 *
 */
export function sendFocusedMetaJson(metaJson: FocusedMetaTags): void {
    if (!appType()) return;

    window.o_apps_android?.onFocusedMetaTagsReceived?.(JSON.stringify(metaJson));
    window.webkit?.messageHandlers?.onFocusedMetaTagsReceived?.postMessage(metaJson);
}
